import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sales-person-menu',
  templateUrl: './sales-person-menu.component.html',
})
export class SalesPersonMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
